module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-right-panel-1-89c51ed56f84c8133f3c5ce43d1111bf.svg";